/**
 * 单据管理-历史记录-公共头部
 * Author:  Fjj
 * History:
 * Date         Version Remarks
 * ============ ======= ======================================================
 * 2022/8/12      1.0     First version  BY GSM
 * 2022/9/13      2.0     Second version 优化处理 BY FJJ
 *
 * Copyright 2016, all rights reserved. Essa.cn
 * */

import React from 'react'
import {Button,message } from 'antd';
import Lang from "@components/Lang/Lang";
import dayjs from "dayjs";
import {toFixed2} from '@utils/utils';
import "../Bill.less";
import ShipperManagementAction from "../../../ShipperManagement.action";

export default class History extends React.Component{
    static defaultProps = {
        showRecover: false,
        recoverUrl:'',
    };
    constructor(props) {
        super(props);
        this.state = {
            list: [],
            orderInfo: {},

            loading: false,
        }
    }
    /**
     * 覆盖历史记录
     * @param item
     */
    recovery(item,recoverUrl){
        this.setState({
            loadingHistory: true
        })
        const postData = {
            id: item.id
        }
        ShipperManagementAction.autoFetchAction(postData,recoverUrl).then(res=>this.handleRecoveryRes(res.data)).catch(err=>this.handleRecoveryRes(err))

    }
    handleRecoveryRes(res){
        const {success,valid} = res;
        if(success&&valid){
            message.success(Lang({id:'CaoZuoChengGong',default: "操作成功",}));
            this.setState({
                visible:false,
                loadingHistory: false
            })
            if(this.props.recoveryHistoryBack)this.props.recoveryHistoryBack()
        }else{
            if(res.message){
                message.warning(res.message);
            } else message.warning(Lang({id:'CaoZuoShiBai',default: "操作失败",}));
        }
    }
    render(){
        const {title,orderInfo, showRecover,recoverUrl } = this.props;
        return (<>
            <div className="margin-bottom-5">
                <h2>{title} {Lang({id: 'BanBen', default: '版本'})}{orderInfo.version}</h2>
                <p className="text-gray">{orderInfo.createTime?dayjs(orderInfo.createTime).format("YYYY-MM-DD"):"-"} {orderInfo.createByName}</p>
            </div>
            <div className="padding-top-10">
                {showRecover&&recoverUrl&&orderInfo.isNew!=1&&<Button type="primary" className={"margin-right-5"}
                                                                 onClick={()=>this.recovery(orderInfo,recoverUrl)}>{Lang({id:'HuiFuCiBanBen',default:'恢复此版本'})}
                </Button>}
                <Button onClick={this.props.callBack}>{Lang({id: 'FanHui', default: '返回'})}</Button>
            </div>
        </>)
    }
}
